import Singleton from "../cache/Singleton.js";

export default class APIs {
  static instance = APIs.instance || new APIs();

  getUserToken(raw) {
    console.log("APIs -> getUserToken() -> raw: ", raw);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch(
      Singleton.instance.BACKEND_URL + "api-token-auth/",
      requestOptions,
      50000
    )
      .then((response) => {
        // Ref -> https://stackoverflow.com/a/46316675/11586503
        console.log(JSON.stringify(response, null, 4));
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        console.log("getUserToken() -> Code", statusCode, " | Data: ", data);
        return [statusCode, data];
      })
      .catch((error) => {
        console.log("error", error);
        return [-1, null];
      });
  }

  getPartnersInSuccess() {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Token " + Singleton.instance.storedUserToken
    );
    // myHeaders.append("Accept-Language", Singleton.instance.currentLanguage);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    // +"partner"
    return fetch(
      Singleton.instance.BACKEND_URL + "partner-category",
      requestOptions,
      50000
    )
      .then((response) => {
        // Ref -> https://stackoverflow.com/a/46316675/11586503
        console.log(JSON.stringify(response, null, 4));
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        console.log(
          "getPartnersInSuccess() -> Code",
          statusCode,
          " | Data: ",
          data
        );
        return [statusCode, data];
      })
      .catch((error) => {
        console.log("error", error);
        return [-1, null];
      });
  }

  getShareholders() {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Token " + Singleton.instance.storedUserToken
    );
    // myHeaders.append("Accept-Language", Singleton.instance.currentLanguage);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      Singleton.instance.BACKEND_URL + "shareholder",
      requestOptions,
      50000
    )
      .then((response) => {
        // Ref -> https://stackoverflow.com/a/46316675/11586503
        console.log(JSON.stringify(response, null, 4));
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        console.log(
          "getPartnersInSuccess() -> Code",
          statusCode,
          " | Data: ",
          data
        );
        return [statusCode, data];
      })
      .catch((error) => {
        console.log("error", error);
        return [-1, null];
      });
  }

  getCoupons() {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Token " + Singleton.instance.storedUserToken
    );
    // myHeaders.append("Accept-Language", Singleton.instance.currentLanguage);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      Singleton.instance.BACKEND_URL + "coupon",
      requestOptions,
      50000
    )
      .then((response) => {
        // Ref -> https://stackoverflow.com/a/46316675/11586503
        console.log(JSON.stringify(response, null, 4));
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        console.log(
          "getPartnersInSuccess() -> Code",
          statusCode,
          " | Data: ",
          data
        );
        return [statusCode, data];
      })
      .catch((error) => {
        console.log("error", error);
        return [-1, null];
      });
  }

  getIssues() {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Token " + Singleton.instance.storedUserToken
    );
    // myHeaders.append("Accept-Language", Singleton.instance.currentLanguage);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      Singleton.instance.BACKEND_URL + "issue",
      requestOptions,
      50000
    )
      .then((response) => {
        // Ref -> https://stackoverflow.com/a/46316675/11586503
        console.log(JSON.stringify(response, null, 4));
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        console.log(
          "getPartnersInSuccess() -> Code",
          statusCode,
          " | Data: ",
          data
        );
        return [statusCode, data];
      })
      .catch((error) => {
        console.log("error", error);
        return [-1, null];
      });
  }

  getBoardMember() {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Token " + Singleton.instance.storedUserToken
    );
    // myHeaders.append("Accept-Language", Singleton.instance.currentLanguage);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      Singleton.instance.BACKEND_URL + "board-member",
      requestOptions,
      50000
    )
      .then((response) => {
        // Ref -> https://stackoverflow.com/a/46316675/11586503
        console.log(JSON.stringify(response, null, 4));
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        console.log("getBoardMember() -> Code", statusCode, " | Data: ", data);
        return [statusCode, data];
      })
      .catch((error) => {
        console.log("error", error);
        return [-1, null];
      });
  }
}
